import { useContext } from 'react';
import { useSearchParams } from "react-router-dom";

import MenuContext from '../store/MenuContext';
import CartClasses from '../components/Cart/Cart.module.css';

const CCFailed = () => {

	const orderData = sessionStorage.getItem('testsOrdered');
	const [searchParams] = useSearchParams();
	const ccID=searchParams.get("session_id");
	sessionStorage.setItem('ccID',ccID);

	const menuTheme = useContext(MenuContext);

   return (<div className={CartClasses.testInfo}>
	   {!orderData && 
			<div className={CartClasses.testInfoContent}>
				No tests were sent with the order.
				
			</div>
	   }
	   {orderData &&
    	    <div className={CartClasses.testInfoContent}>
				Credit card authorization not successful.
				<br />{orderData} was not ordered.
			</div>
	   }
		</div>
	);
}

export default CCFailed;


